let initialState = {
	PdfDownloadStatus: false
};
const PdfDownloadData = (state = initialState, action) => {
	switch (action.type) {
		case "SET_PDF_DOWNLOAD_STATUS":
			return {
				...state,
				PdfDownloadStatus: action.payload,
			};
		default:
			return state;
	}
};

export default PdfDownloadData;